import { TableColumnHeader } from "@/components/shared/table/Table";
import { Button } from "@/components/ui/button";
import { VacationBonus } from "@/graphql/__generated__/graphql";
import { convertBpToDecimal, formatDateLocale, formatNumberLocale, getProvinceNameByCode } from "@/utils/helpers";
import { ColumnDef } from "@tanstack/react-table";
import { TFunction } from "i18next";
import { TrashIcon } from "lucide-react";
import { IntlShape } from "react-intl";

export const getColumnsVacationBonus = (
  intl: IntlShape,
  t: TFunction,
  handleRemoveVacationBonus: (_vacationBonus: VacationBonus) => void,
  isConfigAdmin: boolean,
): ColumnDef<VacationBonus>[] => [
  {
    id: "activeFrom",
    accessorKey: "activeFrom",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:vacationbonus.columns.activationdate")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const activeFrom = new Date(row.getValue("activeFrom"));
      return <div>{formatDateLocale(intl, activeFrom)}</div>;
    }
  },
  {
    accessorKey: "province",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:vacationbonus.columns.province")}
        column={column}
      />
    ),
    cell: ({ row }) => {
      const provinceCode = row.getValue("province") as string;
      return <div>{getProvinceNameByCode(provinceCode, true)}</div>;
    },
  },
  {
    id: "bonusRelative",
    accessorKey: "bonusRelative",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:vacationbonus.columns.bonusrelative")}
        column={column}
        align="end"
      />
    ),
    cell: ({ row }) => {
      const value = parseFloat(row.getValue("bonusRelative"));
      return <div className="text-right font-medium">{convertBpToDecimal(value)}%</div>;
    }
  },
  {
    id: "bonusAbsolute",
    accessorKey: "bonusAbsolute",
    header: ({ column }) => (
      <TableColumnHeader
        text={t("tables:vacationbonus.columns.bonusabsolute")}
        column={column}
        align="end"
      />
    ),
    cell: ({ row }) => {
      const value = parseFloat(row.getValue("bonusAbsolute"));
      return <div className="text-right font-medium">{formatNumberLocale(intl, value, "currency")}</div>;
    }
  },
  ...(isConfigAdmin
    ? [
      {
        accessorKey: "actions",
        size: 40,
        header: () => <div className="flex justify-end"></div>,
        cell: ({ row }) => (
          <div className="flex gap-2 justify-end">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleRemoveVacationBonus(row.original)}
            >
              <TrashIcon className="w-4 h-4 text-red-500" />
            </Button>
          </div>
        ),
      },
    ]
    : []),
];
